import Container from 'components/Container'
import Link from 'components/Link'
import PropTypes from 'prop-types'
import React from 'react'
import theme from 'styles/theme'

const CategoryList = ({ categories, activeCategoryName }) => (
  <Container
    wrapperStyles={{
      backgroundColor: theme.colors.white,
    }}
  >
    <div
      css={{
        display: 'flex',
        flexWrap: 'wrap',
        padding: '1.5rem 0',
        [theme.medium]: {
          justifyContent: 'center',
          padding: '2rem 0 2rem',
        },
        [theme.large]: {
          padding: '4rem 0 4rem',
        },
      }}
    >
      {[
        {
          title: 'All',
          slug: {
            current: '/blog/',
          },
        },
        ...categories,
      ].map(c => (
        <Link
          key={c.id}
          className={activeCategoryName === c.title ? 'active' : ''}
          to={c.slug.current}
          css={{
            ...theme.h4,
            color: theme.colors.spinachDark,
            transition: theme.globalTransition,
            padding: '0.5rem 1.25rem',
            borderRadius: '4px',
            marginRight: '1rem',
            marginBottom: '0.5rem',
            '&:last-child': {
              marginRight: 0,
            },
            '&:hover, &.active': {
              color: theme.colors.spinachBlack,
              background: 'rgba(19, 79, 70, 0.09)',
            },
            [theme.medium]: {
              padding: '0.675rem 2rem',
              marginBottom: '0',
            },
          }}
        >
          <span css={{ position: 'relative', fontWeight: 'bolder' }}>{c.title}</span>
        </Link>
      ))}
    </div>
  </Container>
)

CategoryList.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      slug: PropTypes.shape({ current: PropTypes.string.isRequired }).isRequired,
    })
  ).isRequired,
}

export default CategoryList
